// extracted by mini-css-extract-plugin
module.exports = {"undo_box":"FJUndo_undo_box__3IAft","button":"FJUndo_button__2sjU2","disabled":"FJUndo_disabled__jI4AJ"};